import LinkComponent from './LinkComponent'

export default LinkComponent
